module.exports = __webpack_public_path__ + "img/logoa.00da371e.png";